import {
  Box,
  chakra,
  Container,
  Link,
  Show,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
} from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { ReactNode } from "react";
import { FaDiscord, FaInstagram, FaTwitter } from "react-icons/fa";
import Logo from "../../public/images/logo.svg";

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      //bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      //rounded={'full'}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

const ListHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontWeight={"500"} fontSize={"1rem"} mb={7} color="white">
      {children}
    </Text>
  );
};

const LinkWrap = ({
  children,
  href,
}: {
  children: ReactNode;
  href: string;
}) => {
  return (
    <Link href={href}>
      <Text mb={6} fontWeight={500} color="white" fontSize="lg">
        {children}
      </Text>
    </Link>
  );
};

export default function LargeWithNewsletter() {
  const t = useTranslations("footer");

  return (
    <Box
      bg={"neutral.850"}
      color={useColorModeValue("gray.700", "gray.200")}
      borderTop="2px solid #010613"
    >
      <Container as={Stack} maxW={"6xl"} py={14}>
        <SimpleGrid
          templateColumns={{ base: "1fr", sm: "1fr 1fr" }}
          spacing={8}
        >
          <Stack spacing={6}>
            <Box>
              <a href="https://moongate.id" target="_blank" rel="noreferrer">
                <div className="w-48 cursor-pointer svg-black">
                  <Image src={Logo} alt="moongate" />
                </div>
              </a>
            </Box>
            <Text fontSize={"sm"} fontWeight={600} color="#010613">
              Empowering the Next Generation of Tickets & Memberships.
            </Text>
          </Stack>
          {/* <Stack align={"flex-start"}></Stack> */}
          <Stack align={"flex-start"} spacing={12}>
            {/* <Stack align={"flex-start"}></Stack> */}
            <Stack
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 0, md: 7 }}
            >
              <Stack direction={"row"} spacing={7}>
                <ListHeader>{"Contact us"}</ListHeader>
                <LinkWrap
                  href={
                    "https://themoongate.notion.site/Moongate-FAQs-ffbb9d4ba5084b8abf5a46829c923486"
                  }
                >
                  FAQ
                </LinkWrap>
                <LinkWrap href={"https://moongate.id/terms"}>Terms</LinkWrap>
                <LinkWrap href={"https://moongate.id/privacy"}>
                  Privacy
                </LinkWrap>
              </Stack>
              <Show above="sm">
                <ListHeader>{"|"}</ListHeader>
              </Show>
              <Stack direction={"row"} spacing={7}>
                <SocialButton
                  label={"Twitter"}
                  href={"https://twitter.com/0xmoongate"}
                >
                  <FaTwitter size="1.5rem" color="#010613" />
                </SocialButton>
                <SocialButton
                  label={"Instagram"}
                  href={"https://www.instagram.com/0xmoongate/"}
                >
                  <FaInstagram size="1.5rem" color="#010613" />
                </SocialButton>
                <SocialButton
                  label={"YouTube"}
                  href={"https://discord.com/invite/KpvCUD5NgM"}
                >
                  <FaDiscord size="1.5rem" color="#010613" />
                </SocialButton>
              </Stack>
            </Stack>
          </Stack>
        </SimpleGrid>
      </Container>
    </Box>
  );
}
